let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("do7nn")).then(() => parcelRequire('e2Cll'));